import { useState } from 'react';
import { supabase } from '../../../lib/supabase';

interface FormData {
  roomCount: string;
  currentSystem: string;
  biggestProblem: string;
  fullName: string;
  phone: string;
  email: string;
  businessName: string;
  website: string;
}

const AnalysisForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    roomCount: '',
    currentSystem: '',
    biggestProblem: '',
    fullName: '',
    phone: '',
    email: '',
    businessName: '',
    website: '',
  });

  const steps = [
    { number: 1, name: 'Otel Bilgileri', icon: 'ri-hotel-line' },
    { number: 2, name: 'Mevcut Durum', icon: 'ri-settings-3-line' },
    { number: 3, name: 'İletişim', icon: 'ri-user-line' },
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Supabase'e kaydet (hata olsa bile devam et)
    try {
      await supabase.from('form_submissions').insert([
        {
          room_count: formData.roomCount,
          current_system: formData.currentSystem,
          biggest_problem: formData.biggestProblem,
          full_name: formData.fullName,
          phone: formData.phone,
          email: formData.email,
          business_name: formData.businessName,
          website: formData.website,
        },
      ]);
    } catch (err) {
      console.error('Supabase kayıt hatası:', err);
    }

    // Bildirim e-postası gönder (her durumda çalışır)
    try {
      const response = await fetch('https://xdyjxgwfjcoysmopmamd.supabase.co/functions/v1/notify-form-submission', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhkeWp4Z3dmamNveXNtb3BtYW1kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIxNjk3MzksImV4cCI6MjA4Nzc0NTczOX0.POidJbUwhfbGgESfnXg3MjSL6akwfJhOK6ZsUPU1ayc`,
        },
        body: JSON.stringify({ formData }),
      });
      const result = await response.json();
      console.log('Edge Function yanıtı:', result);
    } catch (err) {
      console.error('Bildirim gönderilemedi:', err);
    }

    setIsSubmitted(true);
  };

  const nextStep = () => {
    if (currentStep < 3) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const updateFormData = (field: keyof FormData, value: string) => {
    setFormData({ ...formData, [field]: value });
  };

  if (isSubmitted) {
    return (
      <section className="py-24 bg-gradient-to-br from-[#0B1D3A] via-[#0F2847] to-[#0B1D3A] relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-20 w-96 h-96 bg-[#D4AF37] rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#C9A961] rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-3xl mx-auto px-6 relative z-10">
          <div className="bg-white/5 backdrop-blur-xl rounded-3xl p-12 border border-[#D4AF37]/20 shadow-2xl text-center">
            <div className="w-24 h-24 bg-gradient-to-br from-[#D4AF37] to-[#C9A961] rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-[#D4AF37]/30">
              <i className="ri-checkbox-circle-line text-5xl text-white"></i>
            </div>
            
            <h2 className="text-4xl font-bold text-white mb-4">
              Talebiniz Alındı! 🎉
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Uzman ekibimiz en kısa sürede sizinle iletişime geçecek.
            </p>
            
            <div className="grid md:grid-cols-2 gap-6 mb-10">
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-[#D4AF37]/10 hover:border-[#D4AF37]/30 transition-all duration-300">
                <div className="w-14 h-14 bg-gradient-to-br from-[#D4AF37] to-[#C9A961] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">Hızlı Yanıt</h3>
                <p className="text-gray-400 text-sm">24 saat içinde geri dönüş yapıyoruz</p>
              </div>
              
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-[#D4AF37]/10 hover:border-[#D4AF37]/30 transition-all duration-300">
                <div className="w-14 h-14 bg-gradient-to-br from-[#D4AF37] to-[#C9A961] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">Ücretsiz Analiz</h3>
                <p className="text-gray-400 text-sm">Hiçbir ücret ödemeden detaylı rapor</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/905524400989"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-xl border border-[#D4AF37]/30 hover:bg-white/20 hover:border-[#D4AF37]/50 transition-all duration-300 hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp ile İletişim
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="analiz-formu" className="py-24 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#D4AF37] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#0B1D3A] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#D4AF37]/10 to-[#C9A961]/10 rounded-full mb-6 border border-[#D4AF37]/20">
            <i className="ri-line-chart-line text-[#D4AF37]"></i>
            <span className="text-sm font-semibold text-[#0B1D3A]">Ücretsiz Gelir Analizi</span>
          </div>
          <h2 className="text-5xl font-bold text-[#0B1D3A] mb-6">
            Otelinizdeki Gelir Kayıplarını<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#C9A961]">
              Hemen Tespit Edin
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            2 dakikalık analizle otelinizdeki gelir kayıplarını ve potansiyel kazancınızı öğrenin
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Sol Taraf - Form */}
          <div className="order-2 lg:order-1">
            <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden">
              {/* Progress Bar */}
              <div className="bg-gradient-to-r from-[#0B1D3A] to-[#0F2847] px-8 py-6">
                <div className="flex items-center justify-between mb-4">
                  {steps.map((step) => (
                    <div key={step.number} className="flex items-center">
                      <div className={`flex items-center justify-center w-12 h-12 rounded-xl transition-all duration-300 ${
                        currentStep >= step.number
                          ? 'bg-gradient-to-br from-[#D4AF37] to-[#C9A961] text-white shadow-lg shadow-[#D4AF37]/30'
                          : 'bg-white/10 text-white/50'
                      }`}>
                        <i className={`${step.icon} text-xl`}></i>
                      </div>
                      {step.number < 3 && (
                        <div className={`hidden sm:block w-16 lg:w-24 h-1 mx-2 rounded-full transition-all duration-300 ${
                          currentStep > step.number ? 'bg-gradient-to-r from-[#D4AF37] to-[#C9A961]' : 'bg-white/20'
                        }`}></div>
                      )}
                    </div>
                  ))}
                </div>
                <div className="text-center">
                  <p className="text-white font-semibold text-lg">{steps[currentStep - 1].name}</p>
                  <p className="text-white/60 text-sm mt-1">Adım {currentStep} / 3</p>
                </div>
              </div>

              {/* Form Content */}
              <form onSubmit={handleSubmit} className="p-8" data-readdy-form id="prime-sales-analysis">
                {currentStep === 1 && (
                  <div className="space-y-6">
                    <div>
                      <label className="block text-sm font-semibold text-[#0B1D3A] mb-3">
                        Otelinizdeki Oda Sayısı
                      </label>
                      <div className="grid grid-cols-2 gap-3">
                        {['1-20', '21-50', '51-100', '100+'].map((option) => (
                          <label
                            key={option}
                            className={`relative flex items-center justify-center p-4 rounded-xl border-2 cursor-pointer transition-all duration-300 ${
                              formData.roomCount === option
                                ? 'border-[#D4AF37] bg-gradient-to-br from-[#D4AF37]/5 to-[#C9A961]/5 shadow-lg'
                                : 'border-gray-200 hover:border-[#D4AF37]/50 hover:bg-gray-50'
                            }`}
                          >
                            <input
                              type="radio"
                              name="roomCount"
                              value={option}
                              checked={formData.roomCount === option}
                              onChange={(e) => updateFormData('roomCount', e.target.value)}
                              className="sr-only"
                              required
                            />
                            <span className={`font-semibold ${
                              formData.roomCount === option ? 'text-[#D4AF37]' : 'text-gray-700'
                            }`}>
                              {option} oda
                            </span>
                            {formData.roomCount === option && (
                              <i className="ri-checkbox-circle-fill text-[#D4AF37] absolute top-2 right-2"></i>
                            )}
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {currentStep === 2 && (
                  <div className="space-y-6">
                    <div>
                      <label className="block text-sm font-semibold text-[#0B1D3A] mb-3">
                        Mevcut Rezervasyon Sisteminiz
                      </label>
                      <div className="space-y-3">
                        {[
                          { value: 'manuel', label: 'Manuel (Excel, Defter)', icon: 'ri-file-list-line' },
                          { value: 'temel-yazilim', label: 'Temel Yazılım', icon: 'ri-computer-line' },
                          { value: 'pms', label: 'PMS Sistemi', icon: 'ri-dashboard-line' },
                          { value: 'yok', label: 'Sistem Kullanmıyorum', icon: 'ri-close-circle-line' },
                        ].map((option) => (
                          <label
                            key={option.value}
                            className={`flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all duration-300 ${
                              formData.currentSystem === option.value
                                ? 'border-[#D4AF37] bg-gradient-to-br from-[#D4AF37]/5 to-[#C9A961]/5 shadow-lg'
                                : 'border-gray-200 hover:border-[#D4AF37]/50 hover:bg-gray-50'
                            }`}
                          >
                            <input
                              type="radio"
                              name="currentSystem"
                              value={option.value}
                              checked={formData.currentSystem === option.value}
                              onChange={(e) => updateFormData('currentSystem', e.target.value)}
                              className="sr-only"
                              required
                            />
                            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                              formData.currentSystem === option.value
                                ? 'bg-gradient-to-br from-[#D4AF37] to-[#C9A961] text-white'
                                : 'bg-gray-100 text-gray-600'
                            }`}>
                              <i className={`${option.icon} text-xl`}></i>
                            </div>
                            <span className={`font-semibold flex-1 ${
                              formData.currentSystem === option.value ? 'text-[#D4AF37]' : 'text-gray-700'
                            }`}>
                              {option.label}
                            </span>
                            {formData.currentSystem === option.value && (
                              <i className="ri-checkbox-circle-fill text-[#D4AF37] text-xl"></i>
                            )}
                          </label>
                        ))}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-[#0B1D3A] mb-3">
                        En Büyük Sorununuz
                      </label>
                      <div className="space-y-3">
                        {[
                          { value: 'dusuk-doluluk', label: 'Düşük Doluluk Oranı', icon: 'ri-hotel-bed-line' },
                          { value: 'yuksek-komisyon', label: 'Yüksek Komisyon Giderleri', icon: 'ri-money-dollar-circle-line' },
                          { value: 'manuel-islemler', label: 'Manuel İşlemler', icon: 'ri-file-edit-line' },
                          { value: 'fiyat-yonetimi', label: 'Fiyat Yönetimi', icon: 'ri-price-tag-3-line' },
                        ].map((option) => (
                          <label
                            key={option.value}
                            className={`flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all duration-300 ${
                              formData.biggestProblem === option.value
                                ? 'border-[#D4AF37] bg-gradient-to-br from-[#D4AF37]/5 to-[#C9A961]/5 shadow-lg'
                                : 'border-gray-200 hover:border-[#D4AF37]/50 hover:bg-gray-50'
                            }`}
                          >
                            <input
                              type="radio"
                              name="biggestProblem"
                              value={option.value}
                              checked={formData.biggestProblem === option.value}
                              onChange={(e) => updateFormData('biggestProblem', e.target.value)}
                              className="sr-only"
                              required
                            />
                            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                              formData.biggestProblem === option.value
                                ? 'bg-gradient-to-br from-[#D4AF37] to-[#C9A961] text-white'
                                : 'bg-gray-100 text-gray-600'
                            }`}>
                              <i className={`${option.icon} text-xl`}></i>
                            </div>
                            <span className={`font-semibold flex-1 ${
                              formData.biggestProblem === option.value ? 'text-[#D4AF37]' : 'text-gray-700'
                            }`}>
                              {option.label}
                            </span>
                            {formData.biggestProblem === option.value && (
                              <i className="ri-checkbox-circle-fill text-[#D4AF37] text-xl"></i>
                            )}
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {currentStep === 3 && (
                  <div className="space-y-5">
                    <div className="grid md:grid-cols-2 gap-5">
                      <div>
                        <label className="block text-sm font-semibold text-[#0B1D3A] mb-2">
                          Ad Soyad *
                        </label>
                        <input
                          type="text"
                          name="fullName"
                          value={formData.fullName}
                          onChange={(e) => updateFormData('fullName', e.target.value)}
                          className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-[#D4AF37] focus:ring-4 focus:ring-[#D4AF37]/10 outline-none transition-all duration-300 text-sm"
                          placeholder="Adınız ve soyadınız"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-[#0B1D3A] mb-2">
                          Telefon *
                        </label>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={(e) => updateFormData('phone', e.target.value)}
                          className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-[#D4AF37] focus:ring-4 focus:ring-[#D4AF37]/10 outline-none transition-all duration-300 text-sm"
                          placeholder="+90 5XX XXX XX XX"
                          required
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-[#0B1D3A] mb-2">
                        E-posta *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={(e) => updateFormData('email', e.target.value)}
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-[#D4AF37] focus:ring-4 focus:ring-[#D4AF37]/10 outline-none transition-all duration-300 text-sm"
                        placeholder="ornek@email.com"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-[#0B1D3A] mb-2">
                        İşletme Adı *
                      </label>
                      <input
                        type="text"
                        name="businessName"
                        value={formData.businessName}
                        onChange={(e) => updateFormData('businessName', e.target.value)}
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-[#D4AF37] focus:ring-4 focus:ring-[#D4AF37]/10 outline-none transition-all duration-300 text-sm"
                        placeholder="Otel adınız"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-[#0B1D3A] mb-2">
                        Web Sitesi (Opsiyonel)
                      </label>
                      <input
                        type="text"
                        name="website"
                        value={formData.website}
                        onChange={(e) => updateFormData('website', e.target.value)}
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-[#D4AF37] focus:ring-4 focus:ring-[#D4AF37]/10 outline-none transition-all duration-300 text-sm"
                        placeholder="https://oteliniz.com"
                      />
                    </div>

                    <div className="bg-gradient-to-br from-[#D4AF37]/5 to-[#C9A961]/5 rounded-xl p-4 border border-[#D4AF37]/20">
                      <div className="flex items-start gap-3">
                        <i className="ri-shield-check-line text-[#D4AF37] text-xl mt-0.5"></i>
                        <p className="text-xs text-gray-600 leading-relaxed">
                          Bilgileriniz güvenle saklanır ve sadece size özel analiz için kullanılır. Üçüncü şahıslarla paylaşılmaz.
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* Navigation Buttons */}
                <div className="flex gap-4 mt-8">
                  {currentStep > 1 && (
                    <button
                      type="button"
                      onClick={prevStep}
                      className="flex-1 px-6 py-4 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-all duration-300 whitespace-nowrap"
                    >
                      <i className="ri-arrow-left-line mr-2"></i>
                      Geri
                    </button>
                  )}
                  {currentStep < 3 ? (
                    <button
                      type="button"
                      onClick={nextStep}
                      className="flex-1 px-6 py-4 bg-gradient-to-r from-[#D4AF37] to-[#C9A961] text-white font-semibold rounded-xl hover:shadow-xl hover:shadow-[#D4AF37]/30 transition-all duration-300 hover:scale-105 whitespace-nowrap"
                    >
                      Devam Et
                      <i className="ri-arrow-right-line ml-2"></i>
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="flex-1 px-6 py-4 bg-gradient-to-r from-[#D4AF37] to-[#C9A961] text-white font-semibold rounded-xl hover:shadow-xl hover:shadow-[#D4AF37]/30 transition-all duration-300 hover:scale-105 whitespace-nowrap"
                    >
                      <i className="ri-send-plane-fill mr-2"></i>
                      Ücretsiz Analiz Al
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>

          {/* Sağ Taraf - Güven Paneli */}
          <div className="order-1 lg:order-2 lg:sticky lg:top-24">
            <div className="space-y-6">
              {/* Ana Güven Kartı */}
              <div className="bg-gradient-to-br from-[#0B1D3A] to-[#0F2847] rounded-3xl p-8 text-white shadow-2xl border border-[#D4AF37]/20">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#D4AF37] to-[#C9A961] rounded-xl flex items-center justify-center">
                    <i className="ri-shield-star-line text-2xl"></i>
                  </div>
                  <h3 className="text-2xl font-bold">Neden Bu Analiz?</h3>
                </div>

                <div className="space-y-4">
                  {[
                    { icon: 'ri-line-chart-line', title: 'Gelir Kayıplarını Tespit Edin', desc: 'OTA komisyonları ve yanlış fiyatlandırma nedeniyle kaybettiğiniz geliri görün' },
                    { icon: 'ri-money-dollar-circle-line', title: 'Potansiyel Kazancınızı Öğrenin', desc: 'Doğru stratejilerle ne kadar daha fazla kazanabileceğinizi keşfedin' },
                    { icon: 'ri-time-line', title: '2 Dakikada Tamamlayın', desc: 'Hızlı ve kolay form ile anında sonuç alın' },
                    { icon: 'ri-gift-line', title: '%100 Ücretsiz', desc: 'Hiçbir ücret ödemeden detaylı analiz raporu' },
                  ].map((item, index) => (
                    <div key={index} className="flex items-start gap-4 p-4 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 hover:bg-white/10 transition-all duration-300">
                      <div className="w-10 h-10 bg-gradient-to-br from-[#D4AF37] to-[#C9A961] rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${item.icon} text-lg`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold mb-1">{item.title}</h4>
                        <p className="text-sm text-gray-300 leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnalysisForm;
